import { render, staticRenderFns } from "./BookList.vue?vue&type=template&id=f48ef13c&scoped=true"
import script from "./BookList.vue?vue&type=script&lang=js"
export * from "./BookList.vue?vue&type=script&lang=js"
import style0 from "./BookList.vue?vue&type=style&index=0&id=f48ef13c&prod&lang=css"
import style1 from "./BookList.vue?vue&type=style&index=1&id=f48ef13c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48ef13c",
  null
  
)

export default component.exports